// --- START OF FILE public/landingpage/js/main.js ---

/**
 * landingpage/js/main.js v1.18 - FIX: Initialize Auth Event Listeners
 * Funzionalità principali della landing page.
 * FIX: Aggiunta la chiamata a `authManager.initEventListeners()` dopo
 *      l'istanziazione di AuthManager. Questo attiva la logica per il toggle
 *      della password (occhietto), che prima non veniva inizializzata.
 * MANTIENE: Logica di inizializzazione e UI centralizzata.
 */

function initializeGlobalManagers() {
    console.log("[Global Managers - Landing] Inizializzazione (v1.18)...");
    if (!window.firebaseServices || !window.firebaseServices.auth || !window.firebaseServices.db) {
        console.error("[Global Managers - Landing Critical Error] Servizi Firebase (auth/db) NON DISPONIBILI.");
        return false;
    }
    try {
        if (!window.authManager) {
            window.authManager = new AuthManager();
            console.log("[GM Landing] AuthManager istanziato.");
            
            // --- FIX: Chiamata al metodo mancante ---
            if (typeof window.authManager.initEventListeners === 'function') {
                window.authManager.initEventListeners();
                console.log("[GM Landing] AuthManager event listeners (password toggle) inizializzati.");
            }
            // --- FINE FIX ---
        }
        if (!window.profileManager) { window.profileManager = new ProfileManager(); console.log("[GM Landing] ProfileManager istanziato."); }
        if (!window.leaderboardManager) { window.leaderboardManager = new LeaderboardManager(); console.log("[GM Landing] LeaderboardManager istanziato."); }
        if (!window.achievementManager && window.profileManager) { const dE={on:()=>{},off:()=>{}}; const dG={scene:{},events:dE,time:{delayedCall:(d,c,a,s)=>setTimeout(()=>c.apply(s,a),d)}}; window.achievementManager = new AchievementManager(window.profileManager, dG); console.log("[GM Landing] AchievementManager istanziato.");}
        else if (!window.profileManager && !window.achievementManager) { console.warn("[GM Landing] ProfileManager mancante per AchievementManager."); }
        if (!window.audioManager && typeof AudioManager !=='undefined' && typeof Howl !=='undefined') { window.audioManager = new AudioManager(); console.log("[GM Landing] AudioManager istanziato."); }
        else if (typeof AudioManager ==='undefined' || typeof Howl ==='undefined') { console.warn("[GM Landing] AudioManager/Howler non definiti."); }
        if(window.leaderboardManager) { if(window.authManager && !window.leaderboardManager.authManager) window.leaderboardManager.authManager=window.authManager; if(window.profileManager && !window.leaderboardManager.profileManager) window.leaderboardManager.profileManager=window.profileManager; }
        console.log("[Global Managers - Landing] Inizializzazione manager completata con successo.");
        return true;
    } catch (e) {
        console.error("[Global Managers - Landing] ERRORE ISTANZIAZIONE MANAGER:", e.message, e.stack);
        return false;
    }
}

document.addEventListener('DOMContentLoaded', function() {
    console.log('[Landing Main v1.18] DOM caricato');
    document.fonts.load('10px Arcade').then(() => console.log('[Landing Main] Font Arcade caricato.')).catch(err => console.warn("Errore font:", err));
    console.log('[Landing Main] Avvio waitForFirebase...');
    waitForFirebase();
    configureSafeAreas();
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);
});

function configureSafeAreas() {
    const safeAreaInsets = getSafeAreaInsets();
    if (safeAreaInsets.top > 0 || safeAreaInsets.left > 0 || safeAreaInsets.right > 0 || safeAreaInsets.bottom > 0) {
        console.log('[Landing Main] Rilevate safe areas:', safeAreaInsets);
        const bodyPaddingLeft = parseInt(window.getComputedStyle(document.body).paddingLeft) || 0;
        const bodyPaddingRight = parseInt(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingLeft = `max(${safeAreaInsets.left}px, ${bodyPaddingLeft}px)`;
        document.body.style.paddingRight = `max(${safeAreaInsets.right}px, ${bodyPaddingRight}px)`;
    }
}

function getSafeAreaInsets() {
    const temp = document.createElement('div');
    temp.style.paddingLeft = 'env(safe-area-inset-left)';
    temp.style.paddingRight = 'env(safe-area-inset-right)';
    temp.style.paddingTop = 'env(safe-area-inset-top)';
    temp.style.paddingBottom = 'env(safe-area-inset-bottom)';
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    const style = window.getComputedStyle(temp);
    const insets = {
        left: parseInt(style.paddingLeft) || 0,
        right: parseInt(style.paddingRight) || 0,
        top: parseInt(style.paddingTop) || 0,
        bottom: parseInt(style.paddingBottom) || 0
    };
    try { document.body.removeChild(temp); } catch(e){}
    return insets;
}

async function waitForFirebase(attempts = 0) {
    const MAX_ATTEMPTS = 15; const WAIT_TIME = 350;
    if (window.firebaseServices && typeof window.firebaseServices.auth !== 'undefined' && typeof window.firebaseServices.db !== 'undefined') {
        console.log('[Landing Main waitForFirebase v1.18] Servizi Firebase base pronti.');
        if (window.firebaseServices.persistenceSetupPromise && typeof window.firebaseServices.persistenceSetupPromise.then === 'function') {
            console.log('[Landing Main waitForFirebase v1.18] Attendo persistenceSetupPromise...');
            try {
                await window.firebaseServices.persistenceSetupPromise;
                console.log('[Landing Main waitForFirebase v1.18] persistenceSetupPromise RISOLTA.');
            } catch (e) {
                console.error('[Landing Main waitForFirebase v1.18] Errore imprevisto attendendo persistenceSetupPromise:', e);
            }
        } else {
            console.warn('[Landing Main waitForFirebase v1.18] persistenceSetupPromise non trovata!');
        }
        if (initializeGlobalManagers()) {
            console.log('[Landing Main waitForFirebase v1.18] Manager globali inizializzati. Avvio UI asincrona...');
            initializeLandingPageAsync();
        } else {
            console.error("[Landing Main waitForFirebase v1.18] FALLIMENTO inizializzazione manager globali! UI di base.");
            initializeBasicUI();
        }
        return;
    }
    attempts++;
    if (attempts > MAX_ATTEMPTS) {
        console.error(`[Landing Main v1.18] Servizi Firebase non disponibili dopo ${MAX_ATTEMPTS} tentativi. UI di base.`);
        initializeBasicUI(); return;
    }
    console.log(`[Landing Main waitForFirebase v1.18] Attesa Servizi Firebase (${attempts}/${MAX_ATTEMPTS})...`);
    setTimeout(() => waitForFirebase(attempts), WAIT_TIME);
}

function initializeBasicUI() {
    console.warn('[Landing Main] Init Basic UI (Firebase/Managers non pronti)');
    const loading = document.getElementById('loading'); if (loading) loading.style.display = 'none';
    setupGameButtons();
    const lbBody = document.getElementById('leaderboard-body'); if(lbBody) lbBody.innerHTML = '<tr><td colspan="3" style="text-align: center; padding: 20px; color: #FFAAAA;">Classifica non disponibile</td></tr>';
    const lbArrow = document.getElementById('leaderboard-arrow'); if (lbArrow) lbArrow.classList.remove('visible');
    const lbButton = document.getElementById('leaderboard-button'); if (lbButton) lbButton.disabled = true;
    setLiveVideoSource();
    if(typeof window.updateGlobalUserUI === 'function') window.updateGlobalUserUI(null);
}

function extractYouTubeVideoId(url) {
    if (!url) return null;
    let videoId = null;
    try {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'youtu.be') {
            videoId = urlObj.pathname.substring(1);
        } else if (urlObj.hostname.includes('youtube.com') && urlObj.pathname === '/watch') {
            videoId = urlObj.searchParams.get('v');
        } else if (urlObj.hostname.includes('youtube.com') && urlObj.pathname.startsWith('/embed/')) {
            videoId = urlObj.pathname.split('/')[2];
        }
        if (videoId) {
            const queryIndex = videoId.indexOf('?');
            if (queryIndex > -1) {
                videoId = videoId.substring(0, queryIndex);
            }
        }
    } catch (e) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        if (match && match[1]) {
            videoId = match[1];
        }
    }
    return videoId;
}

function setLiveVideoSource() {
    const iframe = document.getElementById('live-video-iframe');
    const videoContainer = iframe?.closest('.video-visual');
    if (!iframe) {
        if (videoContainer) videoContainer.style.display = 'none';
        return;
    }
    if (window.latestVideoData && window.latestVideoData.url) {
        const sourceUrl = window.latestVideoData.url;
        const startTime = window.latestVideoData.startTimeSeconds || 0;
        const videoId = extractYouTubeVideoId(sourceUrl);
        if (videoId) {
            const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&controls=0&start=${startTime}`;
            iframe.src = embedUrl;
            if (videoContainer) { videoContainer.style.display = 'block'; }
        } else {
            if (videoContainer) { videoContainer.style.display = 'none'; } else { iframe.style.display = 'none'; }
        }
    } else {
        if (videoContainer) { videoContainer.style.display = 'none'; } else if (iframe) { iframe.style.display = 'none'; }
    }
}

async function initializeLandingPageAsync() {
    console.log('[Landing Main v1.18] initializeLandingPageAsync START');
    const loading = document.getElementById('loading');
    function showLoading() { if (loading) loading.style.display = 'flex'; }
    function hideLoading() { if (loading) loading.style.display = 'none'; }
    showLoading();
    try {
        if (window.LandingPageAuthUI?.initialize) window.LandingPageAuthUI.initialize(); else console.error("LandingPageAuthUI non trovato!");
        if (window.LandingPageLeaderboardUI?.initialize) window.LandingPageLeaderboardUI.initialize(); else console.error("LandingPageLeaderboardUI non trovato!");
        if (window.LandingPageProfileUI?.initialize) { if (window.profileManager && window.achievementManager) { window.LandingPageProfileUI.initialize(window.profileManager, window.achievementManager); } else { console.error("Errore: ProfileManager o AM non trovati per LandingPageProfileUI.initialize!"); } } else { console.error("LandingPageProfileUI non trovato!"); }
        if (window.achievementManager?.initialize) window.achievementManager.initialize(); else { console.warn("[Landing Main] AM non trovato o non inizializzabile."); }
        if (!window.authManager) throw new Error("AuthManager non disponibile post-init!");
        await window.authManager.waitForAuthReady();
        if(typeof window.updateGlobalUserUI === 'function') window.updateGlobalUserUI(window.authManager.currentUser);
        if(window.authManager.isAuthenticated() && window.profileManager) { await window.profileManager.loadUserCache(window.authManager); }
        if (window.LandingPageLeaderboardUI?.loadLeaderboard) window.LandingPageLeaderboardUI.loadLeaderboard('weekly');
        setLiveVideoSource();
        setupGameButtons();
        setupSocialLinkListeners();
        handleWindowResize(); 
        window.removeEventListener('resize', handleWindowResize);
        window.addEventListener('resize', handleWindowResize);
    } catch (error) {
        console.error("[Landing Main v1.18] ERRORE CRITICO init:", error);
        initializeBasicUI();
    } finally {
        hideLoading();
        console.log('[Landing Main v1.18] initializeLandingPageAsync END.');
    }
}

window.updateGlobalUserUI = function(user) {
    const authButtons = document.getElementById('auth-buttons');
    const userInfo = document.getElementById('user-info');
    const userNameEl = document.getElementById('user-name');
    const readyActionButton = document.getElementById('ready-action-button');
    const isAuthenticated = !!user;
    let finalDisplayName = 'Utente';
    if (isAuthenticated) {
        if (user.displayName) {
            finalDisplayName = user.displayName;
        } else if (window.authManager) {
            finalDisplayName = window.authManager.getUserDisplayName();
            if (finalDisplayName === 'PLAYER' || !finalDisplayName) {
                finalDisplayName = 'Profilo';
            }
        } else if (user.email) {
            finalDisplayName = user.email.split('@')[0].toUpperCase();
        } else {
            finalDisplayName = 'Profilo';
        }
    }
    if (authButtons && userInfo && userNameEl) {
        if (isAuthenticated) {
            authButtons.style.display = 'none';
            userInfo.style.display = 'flex';
            userNameEl.textContent = finalDisplayName;
            userNameEl.title = 'Visualizza Profilo';
            userNameEl.style.cursor = 'pointer';
            userNameEl.style.textDecoration = 'underline';
        } else {
            authButtons.style.display = 'flex';
            userInfo.style.display = 'none';
            userNameEl.textContent = 'Utente';
            userNameEl.title = '';
            userNameEl.style.cursor = 'default';
            userNameEl.style.textDecoration = 'none';
        }
    }
    if (readyActionButton) {
        const startGame = () => {
            if (isAuthenticated && window.authManager) {
                localStorage.setItem('playMode', 'authenticated');
                localStorage.setItem('userId', window.authManager.getUserId());
                localStorage.setItem('userDisplayName', finalDisplayName);
            } else {
                localStorage.setItem('playMode', 'guest');
            }
            localStorage.setItem('fromLanding', 'true');
            window.location.href = '/play';
        };
        const newButton = readyActionButton.cloneNode(true);
        readyActionButton.parentNode.replaceChild(newButton, readyActionButton);
        const currentButton = document.getElementById('ready-action-button');
        if (isAuthenticated) {
            currentButton.textContent = 'GIOCA ORA';
            currentButton.className = 'btn btn-primary';
            currentButton.addEventListener('click', startGame);
        } else {
            currentButton.textContent = 'ACCEDI PER SALVARE PROGRESSI';
            currentButton.className = 'btn btn-secondary';
            if (window.LandingPageAuthUI?.showLoginModal) {
                currentButton.addEventListener('click', window.LandingPageAuthUI.showLoginModal);
            } else {
                currentButton.disabled = true;
            }
        }
    }
};

function setupGameButtons() {
    function startGame() {
        if (window.authManager?.isAuthenticated()) {
            localStorage.setItem('playMode', 'authenticated');
            localStorage.setItem('userId', window.authManager.getUserId());
            localStorage.setItem('userDisplayName', window.authManager.getUserDisplayName());
        } else {
            localStorage.setItem('playMode', 'guest');
        }
        localStorage.setItem('fromLanding', 'true');
        window.location.href = '/play';
    }
    const playButtonIds = ['play-button', 'play-button-bottom'];
    playButtonIds.forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
            newBtn.addEventListener('click', startGame);
        }
    });
}

function handleWindowResize() {
    configureSafeAreas();
    if (typeof setupModalOrientation === 'function') {
        setupModalOrientation();
    }
}

function handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
        if (window.achievementManager && typeof window.achievementManager.processPendingLandingNotifications === 'function') {
            window.achievementManager.processPendingLandingNotifications();
        }
    }
}

function setupSocialLinkListeners() {
    const socialLinks = document.querySelectorAll('a.social-icon, a.btn-social');
    socialLinks.forEach(link => {
        const achievementId = link.dataset.achievementId;
        if (achievementId) {
            link.removeEventListener('click', handleSocialLinkClick);
            link.addEventListener('click', handleSocialLinkClick);
        }
    });
}

function handleSocialLinkClick(event) {
    const link = event.currentTarget;
    const achievementId = link.dataset.achievementId;
    if (!achievementId) return;
    const profileMgr = window.profileManager;
    const authMgr = window.authManager;
    const achievementMgr = window.achievementManager;
    if (!profileMgr || !authMgr || !achievementMgr) return;
    const isLoggedIn = authMgr.isAuthenticated();
    const achievements = profileMgr.getUserAchievements();
    const alreadyUnlocked = isLoggedIn && achievements && achievements[achievementId];
    if (isLoggedIn && !alreadyUnlocked) {
        achievementMgr.attemptUnlock(achievementId);
    }
}

// --- END OF FILE public/landingpage/js/main.js ---